import { h, Component } from 'preact';
import Phone from 'components/bolt/icons/phone';
import Store from 'store/store';
import s from 'components/bolt/landscapeOverlay/landscapeOverlay.sss';

export default class LandscapeOverlay extends Component {

	componentDidMount() {
		if (Store.get().quizPhotobooth) {
			Store.emit('TRACK_QUIZPHOTOBOOTH_VIEW', 'rotate-device');
		}
	}

	render() {
		return (
			<div className={s.wrapper}>
				<Phone class={s.phoneIcon} ariaLabel="Phone Icon" />
			</div>
		);
	}
}
